import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { ExperienceDetailResource } from '../../../../../CurrentCollectionStep/BuilderV2/Types';

interface Props {
  experienceDetailResource: ExperienceDetailResource;
}

function ExperienceDescription({ experienceDetailResource }: Props) {
  return (
    <Typography variant="caption" className="whitespace-pre-line">
      {experienceDetailResource.payload.description}
    </Typography>
  );
}
export default observer(ExperienceDescription);
